import React, { FC } from 'react';
import clsx from 'clsx';
import { Button, Icon } from '@npm-registry/eapteka-ui';
import { text } from '../../../text';
import { useClearCartButton } from './hooks/useClearCartButton';
import { Modal } from './Modal';
import { ClearCartButtonProps } from './types';
import styles from './ClearCartButton.scss';

export const ClearCartButton: FC<ClearCartButtonProps> = ({
  className,
  iconName = 'trash',
  title = text['clear.title']
}) => {
  const {
    isVisibleClearCart,
    onClickByClearCartButton,
    onCloseClearCartModal,
    onAcceptClearCart
  } = useClearCartButton();
  const rootClassNames = clsx([styles.root, className]);

  return (
    <>
      <Button
        className={rootClassNames}
        variant="filled"
        theme="transparent"
        onClick={onClickByClearCartButton}
      >
        <Icon className={styles.icon} name={iconName} />
        <span className={styles.title}>{title}</span>
      </Button>
      {isVisibleClearCart && (
        <Modal
          callback={onCloseClearCartModal}
          onAccept={onAcceptClearCart}
        />
      )}
    </>
  );
};
